module.exports = __webpack_public_path__ + "pc/img/img_02.c9e1a20d.webp";